<template>
  <div class="mainContainer" @wheel.prevent="handleWheel">
    <div class="mainHeader" v-if="currentIndex != 0">
      <div class="mainHeaderInner">
        <img src="../../assets/new/logo.png" class="headerLogo" />
        <div class="headerLoginBtn" @click="$refs.carousel.setActiveItem(0)">
          登录
        </div>
      </div>
    </div>

    <el-carousel ref="carousel" height="100vh" :autoplay="false" :loop="false" :arrow="'never'"
      :indicator-position="'none'" direction="vertical" @change="onSlideChange">
      <el-carousel-item>
        <Login></Login>
      </el-carousel-item>
      <el-carousel-item>
        <div class="contentContain" v-if="introShow">
          <div class="resizeContain">
            <img src="../../assets/new/title1.png" class="titleImg" />
            <div class="creatorIntro">
              顶端创作者MCN，是顶端新闻官方媒体打造的创作生态体，凝聚大V力量、创新奥论引导方式、壮大主流声量，实现创作圈层的顶端集结。通过“创意策划-话题共创-IP孵化”，聚焦顶端作家、顶端军事顶端财经等垂直赛道，打造“一垂类一标杆，一IP一特色”的多元化内容矩阵。
            </div>
            <el-carousel height="607px" :interval="10000" arrow="always" :indicator-position="'none'"
              class="creatorSwiper">
              <el-carousel-item v-for="(item, index) in creators" :key="index">
                <div class="creatorCard" v-for="(item1, index1) in item" :key="index1" @click="toCreator(item1)">
                  <img :src="item1.head" class="headImg" />
                  <div class="creatorName">{{ item1.name }}</div>
                  <div class="creatorTag">{{ item1.tag }}</div>
                  <div class="creatorBottomIntro">
                    {{
                      item1.intro +
                      (item1.label ? "，" : "") +
                      (item1.label || "")
                    }}
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
            <div class="moreCreator" @click="jumpFn('https://m.topnews.cn/a/pages/mcn/creator')">
              查看更多创作者
            </div>
          </div>
        </div>
      </el-carousel-item>
      <el-carousel-item>
        <div class="contentContain contentContain1" v-if="introShow">
          <div class="resizeContain">
            <img src="../../assets/new/title2.png" class="titleImg" />
            <div class="channelContain" :class="{ channelContainLeft: channelActive > -1 }">
              <div class="channelList">
                <div class="channelItem" v-for="(item, index) in channels" :key="index">
                  <img :src="require('../../assets/new/icon' + item.id + '.png')" class="channelIcon" />
                  <div class="channelText">
                    <div class="channelNameContain">
                      <div class="channelName" @click="channelActive = index">
                        {{ item.name }}
                      </div>
                      <img src="../../assets/new/plus@2x.png" class="plusIcon" v-if="channelActive != index"
                        @click="channelActive = index" />
                      <img src="../../assets/new/x@2x_1.png" class="xIcon" v-else @click="channelActive = -1" />
                    </div>
                    <div class="channelIntro" v-html="item.intro" v-if="channelActive == index"></div>
                  </div>
                </div>
              </div>
              <div class="imgContain" v-if="channelActive > -1">
                <img :src="require('../../assets/new/img' +
                  (channelActive + 1) +
                  '.png')
                  " class="channelImg" />
              </div>
            </div>
          </div>
        </div>
      </el-carousel-item>
      <el-carousel-item>
        <div class="contentContain contentContain2" v-if="introShow">
          <div class="resizeContain">
            <img src="../../assets/new/title3.png" class="titleImg" />
            <div class="coopList">
              <div v-for="(item, index) in coops" :key="index" class="coopItem"
                :class="{ 'float-up': coopActive == index }" @mouseenter="coopActive = index"
                @mouseleave="coopActive = -1">
                <img :src="require('../../assets/new/coop' + index + '.png')" class="coopImg" />
                <div class="coopIntro" v-html="item.intro"></div>
                <div class="coopLine"></div>
                <div class="coopName">{{ item.name }}</div>
              </div>
            </div>
          </div>
          <div class="footerContainer">
            <div class="centerContainer">
              <div class="qrCodeContainer">
                <img src="../../assets/85d81507ebe84f210b224bf8e02c6d76966336a7fff89e02e5f088ed492cce1f.png"
                  class="qrCode" />
              </div>
              <div>
                <p class="qrCodeTitle">手机扫码下载顶端新闻APP</p>
                <p class="linkContainer">
                  <span class="linkBtn" @click="jumpFn('https://www.dingxinwen.cn/')">顶端传媒科技（河南）有限公司</span>
                  丨
                  <span class="linkBtn" @click="jumpFn('https://www.dingxinwen.cn/about')">关于我们</span>
                  丨
                  <span class="linkBtn" @click="
                    jumpFn(
                      'https://activity.dingxinwen.com/creator/static/html/userAgreement.html'
                    )
                    ">用户协议</span>
                  丨
                  <span class="linkBtn" @click="
                    jumpFn(
                      'https://activity.dingxinwen.com/creator/static/html/ddGuide.html'
                    )
                    ">隐私政策</span>
                  丨
                  <span class="linkBtn" @click="jumpFn('https://www.12377.cn/')">网上有害信息举报专区</span>
                  丨
                  <!-- <span class="linkBtn">网络谣言曝光平台</span>丨 -->
                  <span class="linkBtn" @click="
                    jumpFn('https://beian.miit.gov.cn/#/Integrated/index')
                    ">豫ICP备2022017130号-3</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import Login from "./login.vue";

export default {
  data() {
    return {
      currentIndex: 0,
      canScroll: true,
      scale: 1,
      creators: [
        [
          {
            tag: "文学作家",
            id: "381479",
            head: "https://obs.dingxinwen.com/image/20220419/f2a730c08fb4c14b982e2e1b6b297611.png?width=378&height=422&x-oss-process=image/resize,w_200",
            name: "刘震云",
            intro: "中国内地作家",
            label: "茅盾文学奖获得者",
          },
          {
            tag: "文学作家",
            id: "390209",
            head: "https://obs.dingxinwen.com/image/20220527/1653617354_IMG_CROP_20220527100900828.jpeg?x-oss-process=image/resize,w_200",
            name: "周大新",
            intro: "中国当代作家",
            label: "茅盾文学奖获得者",
          },
          {
            tag: "文学作家",
            id: "382355",
            head: "https://obs.dingxinwen.com/image/20220421/1650509294_IMG_CROP_20220421104813596.jpeg?x-oss-process=image/resize,w_200",
            name: "李佩甫",
            intro: "一级文学创作",
            label: "茅盾文学奖获得者",
          },
          {
            tag: "文学作家",
            id: "416059",
            head: "https://obs.dingxinwen.com/image/20220620/1655687184_IMG_CROP_20220620090613402.jpeg?x-oss-process=image/resize,w_200",
            name: "柳建伟",
            intro: "中国文字著作权协会会长",
            label: "茅盾文学奖获得者",
          },
          {
            tag: "国际军事",
            id: "229718587",
            head: "https://image.dingxinwen.com/image/20240616/ee2c0fb824d90f44a339335ff404ee8d.jpeg?x-oss-process=image/resize,w_200",
            name: "金灿荣教授",
            intro: "著名国际问题专家",
            label: "全网粉丝2000万+",
          },
          {
            tag: "国际军事",
            id: "448429",
            head: "https://obs.dingxinwen.com/image/20220803/58f8fb638c6e2c179417f12a31a23090.jpg?width=716&height=716&x-oss-process=image/resize,w_200",
            name: "杜文龙",
            intro: "著名军事专家 资深媒体评论员",
            label: "全网粉丝1000万+",
          },
          {
            tag: "国际军事",
            id: "229686041",
            head: "https://vod.dingxinwen.com/image/default/1F40A8BAAE374A249D13211F2DA6A9A6-6-2.jpg?x-oss-process=image/resize,w_200",
            name: "听风的蚕",
            intro: "头部军事自媒体 军事评书开创者",
            label: "全网粉丝5000万+",
          },
          {
            tag: "国际军事",
            id: "575847",
            head: "https://obs.dingxinwen.com/image/20221116/ceb274faaf3d4bde84603f0736e1fb67.jpeg?x-oss-process=image/resize,w_200",
            name: "罗援",
            intro: "军事专家",
            label: "全网粉丝200万+",
          },
          {
            tag: "文化艺术",
            id: "505107",
            head: "https://obs.dingxinwen.com/image/20221018/cd54ea968aaacf9bc157750fa3aeead8.jpeg?x-oss-process=image/resize,w_200",
            name: "李树建",
            intro: "中国剧协副主席",
            label: "一级演员",
          },
          {
            tag: "文化艺术",
            id: "506909",
            head: "https://obs.dingxinwen.com/image/20221020/44f6ad2663ba3a5d3c618caf4766201b.jpeg?x-oss-process=image/resize,w_200",
            name: "金不换",
            intro: "河南省鹤壁市豫剧院院长",
            label: "一级演员",
          },
        ],
        [
          {
            tag: "文化艺术",
            id: "418360",
            head: "https://obs.dingxinwen.com/image/20220628/d19f5cf1e91b51974224f7c5144d06a9.jpeg?x-oss-process=image/resize,w_200",
            name: "意公子",
            intro: "著名艺术自媒体人",
            label: "全网粉丝3500万+",
          },
          {
            tag: "文化艺术",
            id: "506924",
            head: "https://image.dingxinwen.com//image/20230723/7d4dec60a1e8eda8cbbf3d71500395d8.jpeg?x-oss-process=image/resize,w_200",
            name: "张晓英",
            intro: "河南省曲剧团演员",
            label: "二级演员",
          },
          {
            tag: "财经金融",
            id: "229745254",
            head: "https://image.dingxinwen.com//image/20240703/140ce8e224e70ad9b981c9462d07e4ae.png?x-oss-process=image/resize,w_200",
            name: "李稻葵",
            intro: "知名经济学家",
            label: "全网粉丝600万+",
          },
          {
            tag: "财经金融",
            id: "229634534",
            head: "https://image.dingxinwen.com//image/20240422/fad547994f0b09ac76ffbc7230e0a2d0.jpeg?x-oss-process=image/resize,w_200",
            name: "任泽平",
            intro: "知名经济学家",
            label: "全网粉丝1000万+",
          },
          {
            tag: "财经金融",
            id: "230656981",
            head: "https://img.dingxinwen.cn/image/20250516/3bc28c1ce20a22fa0a201c8bbb174d56.jpeg?x-oss-process=image/resize,w_200",
            name: "关权教授",
            intro: "中国人民大学经济学院副教授",
            label: "国际经济专家",
          },
          {
            tag: "财经金融",
            id: "1763860",
            head: "https://obs.dingxinwen.com/image/20230310/7e4f3a8ed0d213e13742d1020340f67d.jpeg?x-oss-process=image/resize,w_200",
            name: "叶檀财经",
            intro: "知名财经大V",
            label: "全网粉丝2000万+",
          },
          {
            tag: "智库专家",
            id: "184446",
            head: "https://image.dingxinwen.com//image/20231120/f6c6e9058abd650950039ce53eb2f01e.jpeg?x-oss-process=image/resize,w_200",
            name: "韩枫桦",
            intro: "智库专家",
            label: null,
          },
          {
            tag: "智库专家",
            id: "503842",
            head: "https://obs.dingxinwen.com/image/20221107/51e9f1b602ab96b32beb695d51484484.jpeg?width=1280&height=1280&x-oss-process=image/resize,w_200",
            name: "王喜成",
            intro: "智库专家",
            label: null,
          },
          {
            tag: "智库专家",
            id: "1954058",
            head: "https://image.dingxinwen.com//image/20230723/d4382bd2d9e82b572c2c92733adcfda0.jpeg?x-oss-process=image/resize,w_200",
            name: "贺建委",
            intro: "智库专家",
            label: null,
          },
          {
            tag: "智库专家",
            id: "570677",
            head: "https://vod.dingxinwen.com/image/default/4C0C52AE040B4D46A81999CB263ABF17-6-2.jpg?x-oss-process=image/resize,w_200",
            name: "沙里淘金财经观察",
            intro: "智库专家",
            label: null,
          },
        ],
        [
          {
            tag: "教育育儿",
            id: "229715568",
            head: "https://image.dingxinwen.com//image/20240611/d7aff613018a541f344d346ffe9996be.png?x-oss-process=image/resize,w_200",
            name: "石品",
            intro: "郑州美术学院院长",
            label: "一级美术师",
          },
          {
            tag: "教育育儿",
            id: "202425",
            head: "https://img.dingxinwen.cn/image/20250318/c36bb6d9b004b077b4c1ce6855fa4791.jpeg?x-oss-process=image/resize,w_200",
            name: "朱奎鹏",
            intro: "河南省名师",
            label: "河南最美教师",
          },
          {
            tag: "教育育儿",
            id: "230463350",
            head: "https://img.dingxinwen.cn/image/20250312/a59cb4deac71defe75197eda89b42972.jpeg?x-oss-process=image/resize,w_200",
            name: "河南省贾福霞名班主任工作室",
            intro: "河南省名师",
            label: "河南最美教师",
          },
          {
            tag: "教育育儿",
            id: "230620626",
            head: "https://img.dingxinwen.cn/image/20250508/53b08581233f9ba44f94b406d565d961.jpeg?x-oss-process=image/resize,w_200",
            name: "葛操心理咨询与督导",
            intro: "河南省知名的心理咨询师培训师",
            label: "郑州大学心理学教授",
          },
          {
            tag: "旅行摄影",
            id: "229559161",
            head: "https://image.dingxinwen.com/image/20240403/d89de9c1e26860f9cd6338f3e5ad2d1e.jpeg?x-oss-process=image/resize,w_200",
            name: "幻想家japaul",
            intro: "国内知名旅游博主",
            label: "全网粉丝2000万+",
          },
          {
            tag: "旅行摄影",
            id: "1651706",
            head: "https://obs.dingxinwen.com/image/20221216/9dc09e15b8d26ba5dbd5321ae2aa810b.jpeg?x-oss-process=image/resize,w_200",
            name: "渝帆",
            intro: "旅行玩家",
            label: "全网粉丝300万+",
          },
          {
            tag: "旅行摄影",
            id: "1645749",
            head: "https://obs.dingxinwen.com/image/20221215/3dba270df5268e0b2da9a357501d2700.jpeg?x-oss-process=image/resize,w_200",
            name: "旅游狂魔夏夏夏 ",
            intro: "旅行自媒体 环球旅游600城",
            label: "微博粉丝100万+",
          },
          {
            tag: "旅行摄影",
            id: "490873",
            head: "https://obs.dingxinwen.com/image/20220831/6c5ef40b5738dd97f04da09c0b3a3fa4.jpeg?x-oss-process=image/resize,w_200",
            name: "晓岚边画边游",
            intro: "前《旅游世界》杂志西南区首席记者",
            label: "抖音粉丝100万+",
          },
          {
            tag: "美食餐饮",
            id: "367820",
            head: "https://obs.dingxinwen.com/image/20220525/47cebe7b5cc67117b59157c55ccfff2f.jpg?width=640&height=640&x-oss-process=image/resize,w_200",
            name: "餐企老板内参",
            intro: "餐饮业首席经管新媒体",
            label: "全网粉丝500万+",
          },
          {
            tag: "美食餐饮",
            id: "367929",
            head: "https://img.dingxinwen.cn/image/20250620/a49ef8013691085fd65108173857a9a9.jpg?x-oss-process=image/resize,w_200",
            name: "红餐网",
            intro: "头号餐饮产业媒体",
            label: null,
          },
        ],
      ],
      channels: [
        {
          id: 1,
          name: "顶端作家",
          intro:
            "顶端文学产业研究院x顶端作家MCN 出品<br>打造成为中国优质文学集散地和中国文学爱好者的聚集地",
        },
        {
          id: 2,
          name: "顶端文化",
          intro:
            "顶端文化创作者MCN 出品<br>旨在打破各文化界别的次元壁，助推河南文化发展",
        },
        {
          id: 3,
          name: "顶端文旅",
          intro:
            "顶端城市文化IP研究院x顶端文旅创作者MCN 出品<br>助力河南文化传播、城市文化名片打造",
        },
        {
          id: 4,
          name: "顶端军事",
          intro:
            "顶端军事创作者MCN 出品<br>深度拆解宏观事件，解读热点事件背后的深层逻辑",
        },
        {
          id: 5,
          name: "顶端财经",
          intro:
            "顶端产业经济研究院 x顶端财经创作者MCN 出品<br>财经专家从不同侧面共论热点事件启示录",
        },
        {
          id: 6,
          name: "顶端健康",
          intro:
            "顶端健康创作者MCN 出品<br>一杯“心”茶心理沙龙，以茶为媒，聚焦青少年心理健康问题",
        },
      ],
      channelActive: 0,
      channelT: null,
      coops: [
        {
          name: "定制合作",
          intro: "基于品牌核心诉求<br>量身打造高契合度图文/视频内容",
        },
        {
          name: "共创合作",
          intro: "专属话题征文<br>邀约创作者共创，形成UGC内容矩阵",
        },
        {
          name: "传播渠道合作",
          intro: "依托创作者跨平台影响力<br>构建立体化传播网络",
        },
      ],
      coopActive: -1,
      introShow: false
    };
  },
  components: {
    Login,
  },
  created() {
    this.setScale();
    window.addEventListener("resize", this.setScale);

    setTimeout(() => {
      this.introShow = true;
    }, 2888)
  },
  mounted() {
    this.channelT = setInterval(() => {
      if (this.channelActive < 5) {
        this.channelActive++;
      } else {
        this.channelActive = 0;
      }
    }, 10000);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.setScale);

    clearInterval(this.channelT);
  },
  methods: {
    handleWheel(event) {
      if (!this.canScroll) return;

      const delta = event.deltaY;
      const carousel = this.$refs.carousel;

      if (delta > 0) {
        if (this.currentIndex < 3) {
          carousel.next();
        }
      } else {
        if (this.currentIndex > 0) {
          carousel.prev();
        }
      }

      this.canScroll = false;
      setTimeout(() => {
        this.canScroll = true;
      }, 800);
    },
    onSlideChange(index) {
      this.currentIndex = index;

      this.setScale();
    },
    setScale() {
      const designWidth = 1920;
      const designHeight = 1012;
      const currentWidth =
        document.documentElement.clientWidth || document.body.clientWidth;
      const currentHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      this.scale =
        currentWidth / designWidth > currentHeight / designHeight
          ? currentHeight / designHeight
          : currentWidth / designWidth;

      const containers = document.getElementsByClassName("resizeContain");
      containers.forEach((container) => {
        if (container) {
          container.style.transform = `scale(${this.scale})`;
          container.style.width = `${designWidth}px`;
          container.style.height = `${(document.documentElement.clientHeight ||
            document.body.clientHeight) / this.scale
            }px`;
        }
      });
    },
    jumpFn(url) {
      window.open(url);
    },
    toCreator(item) {
      window.open(`https://m.topnews.cn/home/${item.id}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.mainContainer {
  background: #fff;
  position: relative;

  .mainHeader {
    width: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 5;
    background-color: #fff;

    .mainHeaderInner {
      width: 1352px;
      height: 68px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 0 auto;
    }

    .headerLogo {
      height: 30px;
    }

    .headerLoginBtn {
      border-radius: 4.67px;
      background: #f32432;
      padding: 0 20px;
      color: #ffffff;
      font-family: "PingFang SC";
      font-size: 10.89px;
      font-weight: 400;
      line-height: 28px;
      cursor: pointer;
    }
  }

  .contentContain {
    height: calc(100vh - 68px);
    background: url(../../assets/new/Group2323.jpg) no-repeat;
    background-size: 100% 100%;
    margin: 68px 0 0 0;
    display: flex;
    justify-content: center;
    align-items: center;

    .titleImg {
      width: 652px;
      margin-top: 0;
    }

    .creatorIntro {
      width: 1167px;
      color: #1a1a1a;
      font-family: "PingFang SC";
      font-size: 18px;
      font-weight: 400;
      line-height: 25px;
      padding-top: 36px;
      text-align: center;
    }

    .creatorSwiper {
      width: 1452px;
      overflow-y: hidden;

      .el-carousel__item {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;

        .creatorCard {
          width: 248px;
          height: 242px;
          border-radius: 12px;
          background: #fff;
          margin: 61px 8px 0 8px;
          position: relative;
          padding: 85px 24px 0 24px;
          cursor: pointer;

          .headImg {
            width: 94px;
            height: 94px;
            border-radius: 94px;
            position: absolute;
            top: -25px;
            left: 50%;
            margin-left: -47px;
            object-fit: cover;
          }

          .creatorName {
            color: #1a1a1a;
            text-align: center;
            font-family: "PingFang SC";
            font-size: 18px;
            font-weight: 500;
            line-height: 25px;
            letter-spacing: 0.18px;
          }

          .creatorTag {
            color: #9092ab;
            text-align: center;
            font-family: "PingFang SC";
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
            letter-spacing: 0.14px;
            margin-top: 5px;
          }

          .creatorBottomIntro {
            color: #9092ab;
            font-family: "PingFang SC";
            font-size: 12px;
            font-weight: 400;
            line-height: 17px;
            letter-spacing: 0.12px;
            margin-top: 16px;
          }
        }
      }

      /deep/.el-carousel__arrow {
        width: 50px !important;
        height: 50px !important;
        box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
        background-color: #ffffff;
        color: #2a9dff33;
        font-size: 22px;
        top: 54%;
      }

      /deep/.el-carousel__arrow--left {
        left: 0;
      }

      /deep/.el-carousel__arrow--right {
        right: 0;
      }
    }

    .moreCreator {
      background: linear-gradient(180deg, #4a9afe 0%, #0168f3 100%);
      border-radius: 24px;
      padding: 0 48px;
      color: #ffffff;
      font-family: "PingFang SC";
      font-size: 16px;
      font-weight: 400;
      line-height: 48px;
      margin: 56px auto 0 auto;
      cursor: pointer;
    }
  }

  .contentContain1 {
    background: url(../../assets/new/bg2.png) no-repeat;
    background-size: 100% 100%;

    .channelContain {
      height: 958px;
      display: flex;
      align-items: center;
      margin-top: -31px;
      padding-left: 0;

      .channelList {
        width: 562px;
        margin-right: 63px;
        border-top: 1px solid #e4e5f0;

        .channelItem {
          border-bottom: 1px solid #e4e5f0;
          padding: 16px 0 24px 0;
          display: flex;
          justify-content: space-between;

          .channelIcon {
            width: 49px;
            height: 49px;
            margin-right: 16px;
          }

          .channelText {
            flex: 1;

            .channelNameContain {
              height: 49px;
              display: flex;
              align-items: center;
              justify-content: space-between;

              .channelName {
                color: #080c1a;
                font-family: "PingFang SC";
                font-size: 20px;
                font-weight: 500;
                cursor: pointer;
              }

              .xIcon,
              .plusIcon {
                height: 20px;
                cursor: pointer;
              }
            }

            .channelIntro {
              color: #9092ab;
              font-family: "PingFang SC";
              font-size: 16px;
              font-weight: 400;
              line-height: 23px;
              margin-top: 3px;
            }
          }
        }
      }

      .imgContain {
        width: 604px;
        height: 958px;
        background: url(../../assets/new/image7.png) no-repeat;
        background-size: 100% 100%;
        position: relative;

        .channelImg {
          width: 305px;
          height: 680px;
          object-fit: cover;
          position: absolute;
          top: 112px;
          left: 109px;
          border-radius: 32px;
        }
      }
    }

    .channelContainLeft {
      padding-left: 160px;
    }
  }

  .contentContain2 {
    background: url(../../assets/new/Group2080.jpg) no-repeat;
    background-size: 100% 100%;
    position: relative;

    .coopList {
      width: 1102px;
      display: flex;
      justify-content: space-between;
      margin-top: 142px;

      .coopItem {
        width: 346px;
        height: 486px;
        border-radius: 16px;
        border: 1px solid #ffffff80;
        background: linear-gradient(180deg,
            #ffffffb3 0%,
            #ffffffb3 50%,
            #ffffffb3 100%);
        box-shadow: -42px 103px 31px 0 #ffffff00;
        backdrop-filter: blur(10px);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        transition: transform 0.3s ease;
        transform: translateY(0);

        .coopImg {
          width: 240px;
        }

        .coopIntro {
          color: #080c1a;
          text-align: center;
          font-family: "PingFang SC";
          font-size: 16px;
          font-weight: 500;
          line-height: 22px;
          letter-spacing: 0.24px;
          margin-top: 43px;
        }

        .coopLine {
          width: 56px;
          height: 4px;
          border-radius: 2px;
          background-color: #0064fb;
          margin-top: 24px;
        }

        .coopName {
          color: #0064fb;
          text-align: center;
          font-family: "PingFang SC";
          font-size: 30px;
          font-weight: 500;
          line-height: 42px;
          letter-spacing: 0.45px;
          margin-top: 23px;
        }
      }

      .float-up {
        transform: translateY(-20px);
      }
    }

    .footerContainer {
      width: 100%;
      height: 120px;
      background: #ffffff80;
      position: absolute;
      left: 0;
      bottom: 0;
      display: flex;
      justify-content: center;
      align-items: center;

      .centerContainer {
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .qrCodeContainer {
        padding: 3px;
        border-radius: 8px;
        background: rgba(255, 255, 255, 1);
        width: 90px;
        height: 90px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 24px;

        .qrCode {
          width: 100%;
          height: 100%;
        }
      }

      .qrCodeTitle {
        line-height: 28px;
        color: #333333;
        font-size: 20px;
        font-weight: 500;
        font-family: "PingFang SC";
        margin-bottom: 12px;
      }

      .linkContainer {
        line-height: 17px;
        color: #333333b3;
        font-size: 12px;
        font-weight: 400;
        font-family: "PingFang SC";

        .linkBtn {
          cursor: pointer;
        }
      }
    }
  }

  .resizeContain {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 90px;
  }
}
</style>
